<template>
	<div class="deskItems">
		<div class="deskItem" v-if="deskItemDisplay">
			<img :src="deskItemDisplay.reward_image.url" />
		</div>
		<div class="deskItem2" v-if="deskItemDisplay2">
			<img :src="deskItemDisplay2.reward_image.url" />
		</div>
		<div class="deskItem3" v-if="deskItemDisplay3">
				<img v-if="!deskItemDisplay3.reward_animated" :src="deskItemDisplay3.reward_image.url" />
				<img v-else :src="deskItemDisplay3.reward_animated" />
		</div>
	</div>
</template>

<script>
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'DeskItem',
	mixins: [msEdgeImageSwap],
	computed: {
		deskItemDisplay() {
			return this.$store.state.deskItem;
		},
		deskItemDisplay2() {
			return this.$store.state.deskItem2;
		},
		deskItemDisplay3() {
			return this.$store.state.deskItem3;
		},
	},
	watch: {
		deskItemDisplay() {
			const vm = this;
			// delay call so desk items have time to appear before swaping out images if MS Edge
			setTimeout(() => {
				vm.swapEdgeImages();
			}, 100);
		},
		deskItemDisplay2() {
			const vm = this;
			// delay call so desk items have time to appear before swaping out images if MS Edge
			setTimeout(() => {
				vm.swapEdgeImages();
			}, 100);
		},
		deskItemDisplay3() {
			const vm = this;
			// delay call so desk items have time to appear before swaping out images if MS Edge
			setTimeout(() => {
				vm.swapEdgeImages();
			}, 100);
		},
	},
};
</script>

<style lang="scss" scoped>
	.deskItems{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		pointer-events: none;
		z-index: 1;
	}
	.deskItem{
		width: 16%;
		height: auto;
		position: absolute;
		top: 58%;
		left: 18%;
	}
	.deskItem2{
		width: 16%;
		height: auto;
		position: absolute;
		top: 71%;
		left: 13%;
	}
	.deskItem3{
		width: 16%;
		height: auto;
		position: absolute;
		top: 60%;
		left: 44.5%;
	}
	img{
		width: 100%;
		height: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/DeskItem.vue